// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MobileIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MobileIcon" ref={forwardedRef} {...props}>
      <path d="M10 15.84a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M5 2a1 1 0 0 0-1 1v13.995a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm.5 1.5h9v8.077h-9zm0 12.995v-3.418h9v3.418z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MobileIcon = /* @__PURE__ */ Object.assign(MobileIconComponent, {
  displayName: 'MobileIcon',
});
